import { createApp } from 'vue';
import store from './store';
import i18n from "@/i18n";
import App from './App.vue';
import router from './router';
import GuestLayout from './layouts/GuestLayout.vue';
import MainLayout from './layouts/MainLayout.vue';
import { IonicVue } from '@ionic/vue';
import { Vue3SlideUpDown } from 'vue3-slide-up-down';
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
/**
 * Ionic Dark Palette
 * -----------------------------------------------------
 * For more information, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */
import '@ionic/core/css/palettes/dark.class.css';
/* Theme variables */
import './theme/variables.css';
import './theme/main.css';
import { EdgeToEdge } from "@capawesome/capacitor-android-edge-to-edge-support";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";
const app = createApp(App);
app.use(IonicVue);
app.use(router);
app.use(store);
app.component('layout-guest', GuestLayout);
app.component('layout-main', MainLayout);
app.component('slide-up-down', Vue3SlideUpDown);
i18n.init().then(localization => {
    app.use(localization);
    router.isReady().then(() => {
        app.mount('#app');
    });
});
window.addEventListener("message", async (event) => {
    const allowedOrigins = process.env.VUE_APP_ALLOWED_ORIGINS ? process.env.VUE_APP_ALLOWED_ORIGINS.split(',') : [];
    if (!allowedOrigins.includes(event.origin))
        return;
    if (event.data) {
        switch (event.data.action) {
            case 'goHome':
                {
                    document.getElementById('gohome')?.click();
                    if (Capacitor.isPluginAvailable('EdgeToEdge')) {
                        await EdgeToEdge.setBackgroundColor({ color: '#f9b000' });
                    }
                    if (Capacitor.isPluginAvailable('StatusBar')) {
                        await StatusBar.setStyle({ style: Style.Dark });
                    }
                }
                break;
            case 'setAppBackgroundColor':
                {
                    if (Capacitor.isPluginAvailable('EdgeToEdge')) {
                        await EdgeToEdge.setBackgroundColor({ color: event.data?.color });
                    }
                }
                break;
        }
    }
}, false);
